import { FunctionComponent, memo, RefObject } from 'react';

import styles from '../custom-select.module.css';

import EditTextWrapper from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/edit-text-wrapper';
import { emptySpace } from '@/utils/empty-space';

type CustomSelectHeaderProps = {
  handlePreventDefaultClick: (e: React.MouseEvent<HTMLElement>) => void;
  isFocused: boolean;
  inputRef: RefObject<HTMLInputElement | null>;
  handleToggleMenu: () => void;
  RenderHeaderLabelContent?: FunctionComponent<{ selectedOptionsCount: number }>;
  selectedOptionsCount: number;
};

const CustomSelectHeader = memo(
  ({
    handlePreventDefaultClick,
    isFocused,
    inputRef,
    handleToggleMenu,
    RenderHeaderLabelContent,
    selectedOptionsCount,
  }: CustomSelectHeaderProps) => {
    return (
      <div
        className={`flex ai-center jc-space-between position-sticky left-0 padding-b-8 ${styles.header}`}
        onPointerDown={handlePreventDefaultClick}
        onClick={() => {
          if (!isFocused) {
            inputRef?.current?.focus();
          } else {
            handleToggleMenu();
          }
        }}
      >
        <div className={`L3 flex-1 ${styles.headerLeft}`}>
          {RenderHeaderLabelContent ? (
            <RenderHeaderLabelContent selectedOptionsCount={selectedOptionsCount} />
          ) : (
            emptySpace
          )}
        </div>
        <div className={styles.headerRight}>
          <EditTextWrapper />
        </div>
      </div>
    );
  }
);

CustomSelectHeader.displayName = 'CustomSelectHeader';

export default CustomSelectHeader;
